import React from 'react';
import { ReactComponent as Inventario } from 'design_system/src/static/icons/motorcycle.svg';
import { ReactComponent as Maps } from 'design_system/src/static/icons/mesh-fill.svg';
import { ReactComponent as UserCircle } from 'design_system/src/static/icons/user-circle.svg';
import { ReactComponent as Building } from 'design_system/src/static/icons/temple.svg';
import { ReactComponent as Pin } from 'design_system/src/static/icons/pin.svg';
import { ReactComponent as LockSquare } from 'design_system/src/static/icons/lock-square.svg';
import { ReactComponent as DashboardIcon } from 'design_system/src/static/icons/compare.svg';
import { ProfileResponse } from 'models/auth/interfaces/auth.interface';
import { CompanyRole } from 'models/companies/enums/companies.enums';
import { Roles } from 'models/ozonio/enums/ozonio.enum';
import { UserType } from 'models/user-management/enums/user-management.enum';
import { isClientUserFromProfile } from 'models/user-management/helpers/client-check';

export type NavItem = {
	to: string;
	img: React.FunctionComponent<
		React.SVGProps<SVGSVGElement> & { title?: string | undefined }
	>;
	name: string;
	auth: Roles[];
};

export type NavSection = {
	label: string;
	items: NavItem[];
};

const clientNav: NavSection[] = [
	{
		label: 'Principal',
		items: [
			{ to: '/dashboard', img: DashboardIcon, name: 'Dashboard', auth: [] },
			{ to: '/map', img: Maps, name: 'Mapa', auth: [] },
		],
	},
	{
		label: 'Inventario',
		items: [{ to: '/assets', img: Inventario, name: 'Activos', auth: [] }],
	},
];

const driverNav: NavSection[] = [
	{
		label: 'Principal',
		items: [{ to: '/map', img: Maps, name: 'Mapa', auth: [] }],
	},
];

const adminNav: NavSection[] = [
	{
		label: 'Gestión',
		items: [
			{ to: '/companies', img: Building, name: 'Companies', auth: [] },
			{ to: '/users', img: UserCircle, name: 'Users', auth: [] },
			{ to: '/geofences', img: Pin, name: 'Geofences', auth: [] },
			{ to: '/api-keys', img: LockSquare, name: 'API Keys', auth: [] },
		],
	},
];

export const getNavForUser = (user: ProfileResponse | null): NavSection[] => {
	if (!user) return [];

	if (user.type === UserType.DRIVER) {
		return driverNav;
	}

	if (
		user.type === UserType.ADMIN &&
		user.company?.role === CompanyRole.ADMIN
	) {
		return adminNav;
	}

	if (isClientUserFromProfile(user)) {
		return clientNav;
	}

	return clientNav;
};

export const filterNavItems = (
	items: NavItem[],
	user: ProfileResponse | null,
): NavItem[] =>
	items.filter(
		(item) =>
			!item.auth?.length || item.auth.some((role) => user?.role.includes(role)),
	);

export const getFlatNavItems = (user: ProfileResponse | null): NavItem[] =>
	getNavForUser(user).flatMap((section) => filterNavItems(section.items, user));

const ASSETS_ROUTE = '/assets';

export const shouldHideAssetsOnMobile = (
	user: ProfileResponse | null,
): boolean => {
	if (!user) return false;
	if (user.type === UserType.DRIVER) return true;
	if (
		user.type === UserType.ADMIN &&
		user.company?.role === CompanyRole.ADMIN
	) {
		return false;
	}
	return true;
};

export const getMobileFlatNavItems = (
	user: ProfileResponse | null,
): NavItem[] => {
	const items = getFlatNavItems(user);
	if (!shouldHideAssetsOnMobile(user)) return items;
	return items.filter((item) => item.to !== ASSETS_ROUTE);
};
